export default __webpack_public_path__ + "static/media/Equity-man.a682806e.png";